/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import SignupPasswordForm from './SignupPasswordForm';
import SignupAuthenticationHelper from 'src/shared/app/signup/component/authentication/base/SignupAuthenticationHelper';
import messages from 'src/shared/app/signup/l10n/passwordSignupL10n';
import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isPasswordSet: boolean,
  handleSubmit: (Object) => Promise<any>,
  handleBack: () => void,
};

const useStyles = createUseStyles(styles);

const SignupPasswordSection = ({
  isPasswordSet,
  handleSubmit,
  handleBack,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(
            isPasswordSet ? messages.headingEnter : messages.headingCreate,
          )}
          handleCancel={handleBack}
          variant={backButton}
        />
      </ZIndexTopBar>
      <SignupPasswordForm
        isPasswordSet={isPasswordSet}
        handleSubmit={handleSubmit}
      />
      <SignupAuthenticationHelper isPasswordSet={isPasswordSet} />
    </section>
  );
};

export default compose(React.memo)(SignupPasswordSection);
